/**
 * Re-export papaparse from the app shell node_modules so module packages (e.g. Pathfinder FE)
 * resolve the same dependency without duplicate path mapping issues.
 */
import Papa from 'papaparse';
export default Papa;
export type { ParseResult, ParseError } from 'papaparse';
